import axios from '../helpers/axios';
import { logError } from '../services';
import { IDropdownResponse } from '../models';
import qs from 'querystring';
import { endOfYesterday } from 'date-fns';
import { IDowntimeDetection } from '../models/downtime-detections';

export const downtimeDectionsQueryKey = `get-downtime-dections`;
export const downtimeDectionTypesQueryKey = `get-downtime-dections-types`;
export const downtimeDectionHealthStatusQueryKey = `get-downtime-dections-health-status`;
const baseURl = `/api/downtime-detections`;

export const getDowntimeDections = async (): Promise<IDowntimeDetection[]> => {
  try {
    const { data } = await axios.get(baseURl, {
      params: {
        from: endOfYesterday().toISOString(),
        to: new Date().toISOString()
      },
      paramsSerializer: params => qs.stringify(params)
    });
    return data;
  } catch (error) {
    logError(error, 'getDowntimeDections failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getDowntimeDectionTypes = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${baseURl}/types`);
    return data;
  } catch (error) {
    logError(error, 'getDowntimeDectionTypes failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getDowntimeDectionHealthStatus = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${baseURl}/health-status`);
    return data;
  } catch (error) {
    logError(error, 'getDowntimeDectionHealthStatus failed');
    return Promise.reject(error?.response?.data);
  }
};
